
export const leftToolbar = 'undo redo clear | h bold italic strikethrough quote tip | ul ol table hr | link image code | save'
export const rightToolbar = 'preview toc sync-scroll fullscreen'
